import numeral from 'numeral';
import { toUpper, isNumber } from 'lodash';

const currencySymbols = {
    GBP: '£',
    EUR: '€',
    USD: '$',
};

export const formatPrice = value => numeral(value).format('0,0');

export const formatSalePrice = (price, curCode) => {
    if (!+price) {
        return '—';
    }

    const currency = toUpper(curCode);
    const currencySymbol = currencySymbols[currency];
    const formattedPrice = formatPrice(price);

    return currencySymbol
        ? `${currencySymbol}${formattedPrice}`
        : `${formattedPrice} ${currency}`;
};

export const formatMoney = number => formatSalePrice(number, 'GBP');

export const formatPrize = (prize) => {
    if (prize < 100) { return ''; }

    const res = prize < 500 ?
        Math.round(prize / 100) / 10 : Math.round(prize / 1000);
    return `${res}K`;
};

export const formatStake = (stake) => {
    if (!isNumber(stake)) { return stake; }
    if (stake === 0) { return '0.00'; }

    return numeral(stake).format('+0.00');
};



// WEBPACK FOOTER //
// ./src/js/utils/money.js